import { useState, useEffect } from 'react'

// Animated "good things take time" loader — shown while a board or route chunk loads.
// (Matches the TicketTailor loading feel, styled for the dark board.)
const MSGS = ['Good things take time…', 'Loading your events…', 'Fetching the latest…', 'Almost there…']

export function Loader() {
  const [i, setI] = useState(0)
  useEffect(() => {
    const t = setInterval(() => setI(n => (n + 1) % MSGS.length), 1500)
    return () => clearInterval(t)
  }, [])
  return (
    <div className="loader-container">
      <div className="brand-loader">
        <div className="brand-loader-emoji">📅</div>
        <div className="brand-loader-msg" key={i}>{MSGS[i]}</div>
        <div className="brand-loader-bar"><i /></div>
      </div>
    </div>
  )
}
